import { mapActions } from "vuex";

export const roleMixins = {
  data() {
    return {
      formData: {
        id: null,
        name: "",
        assistDepartId: 0,
        assistRoleMaterial: {
          introduce: {
            audioSsmlText: "",
            audioText: "",
            displayAudioText: "",
            duration: 0,
            filename: "",
            markFlag: 0,
            materialId: 0,
            materialUrl: "",
            speechRate: 1.0,
            type: "",
            voice: "zhiyuan",
          },
          taskDesc: {
            audioSsmlText: "",
            audioText: "",
            displayAudioText: "",
            duration: 0,
            filename: "",
            markFlag: 0,
            materialId: 0,
            materialUrl: "",
            speechRate: 1.0,
            type: "",
            voice: "zhiyuan",
          },
          taskImage: {
            audioSsmlText: "",
            audioText: "",
            displayAudioText: "",
            duration: 0,
            filename: "",
            markFlag: 0,
            materialId: 0,
            materialUrl: "",
            speechRate: 1.0,
            type: "",
            voice: "zhiyuan",
          },
        },
      },
      form: {
        id: null,
        name: "",
        assistDepartId: 0,
        assistRoleMaterial: {
          introduce: {
            audioSsmlText: "",
            audioText: "",
            displayAudioText: "",
            duration: 0,
            filename: "",
            markFlag: 0,
            materialId: 0,
            materialUrl: "",
            speechRate: 1.0,
            type: "",
            voice: "zhiyuan",
          },
          taskDesc: {
            audioSsmlText: "",
            audioText: "",
            displayAudioText: "",
            duration: 0,
            filename: "",
            markFlag: 0,
            materialId: 0,
            materialUrl: "",
            speechRate: 1.0,
            type: "",
            voice: "zhiyuan",
          },
          taskImage: {
            audioSsmlText: "",
            audioText: "",
            displayAudioText: "",
            duration: 0,
            filename: "",
            markFlag: 0,
            materialId: 0,
            materialUrl: "",
            speechRate: 1.0,
            type: "",
            voice: "zhiyuan",
          },
        },
      },
      imageUrl: "",
      rules: {
        name: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[\s\S]{0,8}$/,
            message: "不得超过8个文字",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions("fuzhu", ["saveRole"]),
    clearForm() {
      this.formData = JSON.parse(JSON.stringify(this.form));
      this.imageUrl = "";
      this.taskDescWarning = false;
      this.introduceWarning = false;
      this.blankWarning = false;
    },
    async handleConfirm() {
      this.handleChange();
      if (
        this.introduceWarning ||
        this.blankWarning ||
        !this.formData.assistRoleMaterial.introduce.audioText
      ) {
        return;
      }
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.saveRole({
            ...this.formData,
          });
          if (this.formData.id) {
            this.$message.success("编辑成功");
          } else {
            this.$message.success("添加成功");
          }
          this.setData({ key: "isBack", value: true });
          this.$router.go(-1);
        }
      });
    },
    async handleAdd() {
      this.handleChange();
      if (
        this.introduceWarning ||
        this.blankWarning ||
        !this.formData.assistRoleMaterial.introduce.audioText
      ) {
        return;
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.saveRole({
            ...this.formData,
          });
          this.$message.success("添加成功");
          this.clearForm();
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
            this.blankWarning = false;
          });
        }
      });
    },
    async handleNext(){
      this.handleChange();
      if (
        this.introduceWarning ||
        this.blankWarning ||
        !this.formData.assistRoleMaterial.introduce.audioText
      ) {
        return;
      }
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          let res = await this.saveRole({
            ...this.formData,
          });
          // console.log(res.data.id)         
          this.$router.replace(
            {
              name: "TaskManagement",
              params: {
                assistRoleId: this.$Base64.encode(res.data.id),
              },
            },
            () => {
            }
          ); 
        }
      });
    }
  },
};
